'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/axios/lib/cancel/isCancel.js
// module id = 122
// module chunks = 0 1